import React from "react"
import Collapse from "@kunukn/react-collapse"

import "./faq.scss"

const FAQItem = props => {
  return (
    <Collapse isOpen={props.isOpen === props.index}>
      <div
        className="faq-item__answer-content"
        dangerouslySetInnerHTML={{ __html: props.answer }}
      />
    </Collapse>
  )
}

export default FAQItem
